import React from 'react'
import { useContext } from 'react'
import { CartContext } from '../context/CartContext'
import styled from 'styled-components'
import { shoppingcart } from '../assets/images'
import StripeCheckoutHandler from '../components/StripeCheckoutHandler'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Container = styled.div`
    padding: 0px 100px;
    @media screen and (max-width:768px){
        padding: 0px 20px;
    }
    .center{
        flex:1; 
        margin-top:10%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    h4{
        text-align:center;
        img{
            height: 40px;
        }
    }
    div{
        div{
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            border: 1px solid var(--border);
            padding: 10px 0px;
            margin: 10px 0px ;
            img{
                height: 80px;
                width: 80px;
                border-radius: 3px;
            }
            h3{
                font-size:16px
            }
            h3, p{margin:0px}
            span{
                margin: 0px;
                height: 20px;
                width: 20px;
                border-radius: 50%;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: var(--border);
                color: black;
                font-weight:900;
                cursor: pointer;
                font-size: 10px;
            }
        }
    }
    select, input{
        width:60px;
        border: 0.5px solid var(--border);
        color: white;
        &:focus{
            border: 0.6px solid var(--border);
        }
        &::placeholder{
            color: gray;
        }
    }
    @media screen and (max-width:768px){
        margin-top:40px;
        div{
            div{
                img{
                    display: none;
                    visibility: hidden;
                }
            }
        }
    }
`
const Button = styled.button`
  padding: 10px;
  background: transparent;
  border-radius: 5px;
  border: 2px solid var(--border);
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%);
    border-radius: 10px;
    opacity: 0.7;
    z-index: -1;
    transition: all 0.2s ease-in-out;
  }

  &:hover:before {
    opacity: 1;
    transform: scale(1.1);
  }
`;
const Cart = () => {
    const {cart, setCart, updateQty, removeItem, formData} = useContext(CartContext)
    const navigate = useNavigate()
    useEffect(()=>{
    let cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    setCart(cartItems)
    // eslint-disable-next-line
    },[])
  return (
    <>
    <Container style={{minHeight:'calc(100vh - 300px)'}}>
        {cart?.length > 0 ? 
        <div style={{display:'flex', flexDirection:'column', justifyContent:'center'}}>
 
        {cart?.map(item => (
            <div key={item.productId}>
                <img src={item.image} alt={item.image}/>
                <h3>{item.title}</h3>
                <p>€ {item.price}</p>
                <p>x</p>
                <p>{item.qty < 10 ?
                 <select value={item.qty} onChange={(e)=>updateQty(item.productId, e.target.value)}>
                    <option value='1'>1</option>
                    <option value='2'>2</option>
                    <option value='3'>3</option>
                    <option value='4'>4</option>
                    <option value='5'>5</option>
                    <option value='6'>6</option>
                    <option value='7'>7</option>
                    <option value='8'>8</option>
                    <option value='9'>9</option>
                    <option value='10'>10+</option>
                 </select>:
                 <input placeholder={item.qty} onBlur={(e)=>updateQty(item.productId, e.target.value)}/>
                 }
                </p>
                <p>€ {(item.price * item.qty).toFixed(2)}</p>
                <span onClick={()=>removeItem(item.productId)}>X</span>

            </div>
        ))}
        <p style={{color:'var(--border)'}}>Please note that €20 will be added to the total amount as delivery charges.</p>
        <StripeCheckoutHandler data={cart} formData={formData}/>
        </div>
        :
        <div className='center'>
            <h4>Your cart is empty <img src={shoppingcart} alt='' /></h4>
        </div>
        }
    </Container>
    <div style={{display:'flex', justifyContent:'flex-end', marginRight:'20px'}}>
        <Button 
            onClick={()=>navigate('/Orders')} 
            style={{color:'var(--border)', cursor:'pointer'}}>
                Check Previous Orders
        </Button>
    </div>
    </>
  )
}

export default Cart